import SearchHead from "components/searchHead";
import SearchForm from "./searchForm";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { SEARCH_FORM_ID_MANAGER } from "components/constent";
import ManagerList from "./list";

export default function Manager() {
  const { t } = useTranslation();

  const [param, setParam] = useState();

  const onSetParam = (param: any) => {
    setParam(param);
  };
  return (
    <>
      <SearchHead
        title={t("manager_detailt_row_ttl")}
        formId={SEARCH_FORM_ID_MANAGER}
        onClick={() => {}}
      />
      <SearchForm onSetParam={onSetParam} />
      <ManagerList param={param} />
    </>
  );
}
